// @ts-nocheck

import StoreRegistry from 'infrastructure/js/utils/StoreRegistry';
import Network from 'infrastructure/js/modules/network';
import * as aiAssistantService from '../../services/AiAssistant/aiAssistantService';
import * as assistantLocalStorage from '../../utils/AiAssistant/aiAssistantStorage';
import {api as aiAssistantFeedbackDialogApi} from './aiAssistantFeedbackDialogActions';
import {api as messageDialogApi} from '../MessageDialog/messageDialogActions';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';

export const actionTypes = {
  AI_ASSISTANT__SHOW_SIDE_PANEL: 'AI_ASSISTANT__SHOW_SIDE_PANEL',
  AI_ASSISTANT__HIDE_SIDE_PANEL: 'AI_ASSISTANT__HIDE_SIDE_PANEL',
  AI_ASSISTANT__SHOW_SIDE_POPUP: 'AI_ASSISTANT__SHOW_SIDE_POPUP',
  AI_ASSISTANT__HIDE_SIDE_POPUP: 'AI_ASSISTANT__HIDE_SIDE_POPUP',
  AI_ASSISTANT__ADD_MESSAGE: 'AI_ASSISTANT__ADD_MESSAGE',
  AI_ASSISTANT__SET_LOADING: 'AI_ASSISTANT__SET_LOADING',
  AI_ASSISTANT__CLEAR_MESSAGES: 'AI_ASSISTANT__CLEAR_MESSAGES',
  AI_ASSISTANT__LOAD_MESSAGES: 'AI_ASSISTANT__LOAD_MESSAGES',
  AI_ASSISTANT__START_STREAMING: 'AI_ASSISTANT__START_STREAMING',
  AI_ASSISTANT__APPEND_CHUNK: 'AI_ASSISTANT__APPEND_CHUNK',
  AI_ASSISTANT__FINISH_STREAMING: 'AI_ASSISTANT__FINISH_STREAMING',
  AI_ASSISTANT__SET_STATUS: 'AI_ASSISTANT__SET_STATUS',
  AI_ASSISTANT__SET_MESSAGE_FEEDBACK: 'AI_ASSISTANT__SET_MESSAGE_FEEDBACK',
};

const actions = {
  showSidePanel: function () {
    return { type: actionTypes.AI_ASSISTANT__SHOW_SIDE_PANEL };
  },
  hideSidePanel: function () {
    return { type: actionTypes.AI_ASSISTANT__HIDE_SIDE_PANEL };
  },
  showSidePopup: function () {
    return { type: actionTypes.AI_ASSISTANT__SHOW_SIDE_POPUP };
  },
  hideSidePopup: function () {
    return { type: actionTypes.AI_ASSISTANT__HIDE_SIDE_POPUP };
  },
  addMessage: function (message) {
    return { type: actionTypes.AI_ASSISTANT__ADD_MESSAGE, payload: message };
  },
  setLoading: function (loading) {
    return { type: actionTypes.AI_ASSISTANT__SET_LOADING, payload: loading };
  },
  clearMessages: function () {
    return { type: actionTypes.AI_ASSISTANT__CLEAR_MESSAGES };
  },
  loadMessages: function (messages) {
    return { type: actionTypes.AI_ASSISTANT__LOAD_MESSAGES, payload: messages };
  },
  startStreaming: function (id, timestamp) {
    return { type: actionTypes.AI_ASSISTANT__START_STREAMING, payload: { id, timestamp } };
  },
  appendChunk: function (chunk) {
    return { type: actionTypes.AI_ASSISTANT__APPEND_CHUNK, payload: chunk };
  },
  finishStreaming: function () {
    return { type: actionTypes.AI_ASSISTANT__FINISH_STREAMING };
  },
  setStatus: function (message) {
    return { type: actionTypes.AI_ASSISTANT__SET_STATUS, payload: message };
  },
  setMessageFeedback: function (index, feedbackType) {
    return { type: actionTypes.AI_ASSISTANT__SET_MESSAGE_FEEDBACK, payload: { index, feedbackType } };
  },
};

export let api = {};

api.showSidePanel = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  dispatch(actions.showSidePanel());
};

api.hideSidePanel = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  dispatch(actions.hideSidePanel());
};

api.setMessageFeedback = function (index, feedbackType) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();
  dispatch(actions.setMessageFeedback(index, feedbackType));
  assistantLocalStorage.saveMessages(getState().aiAssistant.get('messages'));
};

api.showFeedbackDialog = function (data) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  aiAssistantFeedbackDialogApi.show(dispatch, getState)(data);
};


api.showSidePopup = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  dispatch(actions.showSidePopup());
};

api.hideSidePopup = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  dispatch(actions.hideSidePopup());
};

api.toggleSidePopup = function () {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();
  let state = getState().aiAssistant;

  if (state.get('showSidePopup')) {
    dispatch(actions.hideSidePopup());
    return;
  }

  dispatch(actions.showSidePopup());
};

api.toggleSidePanel = function () {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();
  let state = getState().aiAssistant;

  if (state.get('showSidePanel')) {
    dispatch(actions.hideSidePanel());
    return;
  }

  dispatch(actions.showSidePanel());
};

/**
 * Starts a new chat session by clearing messages and regenerating session ID.
 * Called on logout or when user manually starts a new chat.
 */
api.startNewChat = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();

  assistantLocalStorage.clearMessages();
  assistantLocalStorage.regenerateSessionId();

  dispatch(actions.clearMessages());
};

/**
 * Clears only Redux state, preserving LocalStorage.
 * Called on logout to clear in-memory state while keeping chat history persisted.
 */
api.clearReduxMessages = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  dispatch(actions.clearMessages());
};

/**
 * Loads messages from LocalStorage into Redux state.
 * Called after successful login to restore chat history.
 */
api.loadMessages = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  const messages = assistantLocalStorage.loadMessages();
  dispatch(actions.loadMessages(messages));
};


api.sendMessage = async function (text) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  const userMsgId = Date.now();
  dispatch(actions.addMessage({
    id: userMsgId,
    role: 'user',
    text,
    timestamp: userMsgId,
  }));

  assistantLocalStorage.saveMessages(
    getState().aiAssistant.get('messages')
  );

  dispatch(actions.setLoading(true));


  const streamMsgId = Date.now() + 1;
  dispatch(actions.startStreaming(streamMsgId, Date.now()));

  let doneDispatched = false;
  const finishUp = () => {

    if (doneDispatched) {
      return;
    }

    doneDispatched = true;

    dispatch(actions.finishStreaming());
    dispatch(actions.setLoading(false));

    assistantLocalStorage.saveMessages(
      getState().aiAssistant.get('messages')
    );
  };


  try {

    const sessionId = assistantLocalStorage.loadSessionId();

    await aiAssistantService.sendMessageStream({
      prompt: text,
      sessionId,
      onChunk: (chunk) => dispatch(actions.appendChunk(chunk)),
      onStatus: (message) => dispatch(actions.setStatus(message)),
      onDone: finishUp,
      onError: (err) => {
        console.error('AI Assistant stream error:', err);
        finishUp();
      },
    });
  } catch (err) {
    console.error('AI Assistant error:', err);
    finishUp();
  }
};

// Jackson can serialize LocalDateTime either as an ISO string or as an array
// [year, month, day, hour, minute, second, nano] depending on config - handle both defensively
// since the exact wire format for this endpoint wasn't pinned down against a live response.
function parseServerTimestamp(value) {
  if (Array.isArray(value)) {
    const [year, month, day, hour = 0, minute = 0, second = 0] = value;
    return new Date(year, month - 1, day, hour, minute, second).getTime();
  }
  const parsed = new Date(value).getTime();
  return isNaN(parsed) ? Date.now() : parsed;
}

/**
 * Fetches a page of the current user's past conversations for the history panel.
 * @param {{query?: string, pageNumber?: number, pageSize?: number}} params
 * @returns {Promise<{dataList: Array, queryResultInfo: Object}|null>} null on failure.
 */
api.fetchConversations = async function ({ query, pageNumber, pageSize } = {}) {
  const response = await aiAssistantService.getConversations({ query, pageNumber, pageSize });

  if (!Network.isResponseValid(response)) {
    console.error('Failed to fetch AI assistant conversations', response);
    return null;
  }

  return {
    dataList: response.dataList || [],
    queryResultInfo: response.queryResultInfo || null,
  };
};

/**
 * Fetches a single conversation's full transcript for the read-only history view.
 * @param {string} sessionId
 * @returns {Promise<{sessionId: string, title: string|null, messages: Array}|null>}
 * null both on request failure and on the documented not-found/not-owned WARNING response.
 */
api.fetchConversation = async function (sessionId) {
  const response = await aiAssistantService.getConversation(sessionId);

  if (!Network.isResponseValid(response) || response.applicationResponseStatus?.statusType !== 'OK' || !response.data) {
    console.error('Failed to fetch AI assistant conversation', sessionId, response);
    return null;
  }

  const data = response.data;
  return {
    sessionId: data.sessionId,
    title: data.title,
    createdDate: data.createdDate,
    lastMessageDate: data.lastMessageDate,
    messages: (data.messages || []).map((message) => ({
      role: message.role === 'USER' ? 'user' : 'assistant',
      text: message.content,
      timestamp: parseServerTimestamp(message.timestamp),
      incomplete: message.complete === false,
    })),
  };
};

/**
 * Shows a confirmation dialog, then permanently deletes a conversation. Calls onSuccess()
 * so the caller (the history list) can remove the row / refetch.
 * @param {string} sessionId
 * @param {() => void} onSuccess
 */
api.deleteConversation = function (sessionId, onSuccess) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();
  const labels = createLabelHelper('mat.ai.assistant.chat.history.');

  const doDelete = async () => {
    messageDialogApi.close(dispatch, getState)();

    const response = await aiAssistantService.deleteConversation(sessionId);
    if (!Network.isResponseValid(response)) {
      console.error('Failed to delete AI assistant conversation', sessionId, response);
      messageDialogApi.responseError(dispatch, getState)(response);
      return;
    }

    onSuccess?.();
  };

  messageDialogApi.showConfirmation(dispatch, getState)({
    message: labels.get('delete.confirm.message', 'This conversation will be permanently deleted. This cannot be undone.'),
    cancelHandler: messageDialogApi.close(dispatch, getState),
    submitHandler: doDelete,
  });
};
